<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs">Solicitudes de usuarios</p>
        <h2 class="">Solicitudes de usuarios</h2>
    </div>
</div>
<div class="content-block">
    <div class="dx-card responsive-paddings">
        <div class="flex flex-wrap icons-descW mb-3">
            <div class=""><i class="fas fa-exclamation-triangle status-1 status-ico"></i> = Por aprobar</div>
            <div class=""><i class="far fa-check status-2 status-ico"></i> = Aprobada</div>
            <div class=""><i class="far fa-check-square status-3 status-ico"></i> = Completada</div>
            <div class=""><i class="fas fa-times status-4 status-ico"></i> = Rechazada</div>
        </div>
        <dx-data-grid [dataSource]="listRequest" keyExpr="id" [showBorders]="true">
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
            </dxo-pager>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxi-column dataField="companyName" caption="Empresa"></dxi-column>
            <dxi-column dataField="userName" caption="Usuario"></dxi-column>
            <dxi-column alignment="center" dataField="dateCreated" caption="Creada"></dxi-column>
            <dxi-column dataField="concept" caption="Concepto"></dxi-column> 
            <dxi-column dataField="dispersionAmount" caption="Cantidad" dataType="number" format="currency"
                alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="fees" caption="Comisión" dataType="number" format="currency" alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="tax" caption="IVA" dataType="number" format="currency" alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="status" caption="Status" cellTemplate="status" alignment="center"></dxi-column>
            <dxi-column dataField="id" cellTemplate="btn" caption="" alignment="right"></dxi-column>
            <dxo-master-detail [enabled]="true" template="url" ></dxo-master-detail>
            <div *dxTemplate="let data of 'url'">
                <div><span>Mensaje: </span><span><u>{{ data.data.message }}</u></span></div>
                <div><span>Concepto: </span><span><u>{{ data.data.concept }}</u></span></div> 
                <br />
                <div class="master-detail-caption" *ngFor="let item of parseFiles(data.data.url);">
                  <a (click)="dowloadVoucher(item, $event)" [href]="item.url" target="_blank">
                    <i class="fal fa-file-alt"></i>
                    {{ item.name }}
                  </a>
                </div> 
              </div>
            <div *dxTemplate="let d of 'dateTemplate'">
                <div> {{d.value|numberToDate}}</div>
            </div>
            <div *dxTemplate="let d of 'status'">
                <span [innerHTML]="d.value|dispersionStatus"> </span>
            </div>
            <div *dxTemplate="let d of 'btn'">
                <a *ngIf="d.data.status === 1 && udata.level!=7"
                    (click)="changeStatusRequest(d.data,d.data.id,2,d.data.idUsuario,d.data.fees,d.data.tax,d.data.granTotal,udata.email,d.data.dispersionAmount)"
                    class="btn-aprove myPointer">
                    -Aprobar</a>
                    <br />
                <a *ngIf="d.data.status === 1 && udata.level!=7"
                    (click)="changeStatusRequest(d.data,d.data.id,4,d.data.idUsuario,d.data.fees,d.data.tax,d.data.granTotal,d.data.email,d.data.dispersionAmount)"
                    class="btn-aprove myPointer">
                    -Rechazar</a>
                <a *ngIf="d.data.status === 2"
                    (click)="changeStatusRequest(d.data,d.data.id,1,d.data.idUsuario,d.data.fees,d.data.tax,d.data.granTotal,udata.email,d.data.dispersionAmount)"
                    class="btn-aprove myPointer">
                    - Desaprobar</a>
            </div>
        </dx-data-grid>
    </div>
</div>